import { render, staticRenderFns } from "./CreateHiringNote.vue?vue&type=template&id=c2ecec78&"
import script from "./CreateHiringNote.vue?vue&type=script&lang=js&"
export * from "./CreateHiringNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports